import React, { useEffect, useState } from 'react'
import { Box, Button, Collapse, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Countdown, { CountdownRenderProps } from 'react-countdown'
import { Modal } from '../../../../components'

const Renderer: React.FC<CountdownRenderProps> = ({ hours, minutes }) => {
  return (
    <>
      <span>{hours}&nbsp;ч.&nbsp;</span>&nbsp;
      <span>{minutes}&nbsp;мин.&nbsp;</span>
    </>
  )
}

const Timer: React.FC<{ timeEnd: number }> = ({ timeEnd = 0 }) => {
  return <Countdown date={timeEnd} renderer={(props) => <Renderer {...props} />} />
}

export const ConfirmListModal: React.FC<{
  data: any
  show: boolean
  onConfirm: () => void
  onClose: (cross: boolean) => void
}> = ({ data = [], show = false, onConfirm = () => {}, onClose = () => {} }): JSX.Element => {
  const classes = useStyles()

  const [collapse, setCollapse] = useState<boolean>(true)

  const onCloseModal = (cross: boolean) => {
    onClose(cross)
    setCollapse(false)
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  return (
    <Modal open={show} title="Чек-лист" maxWidth="sm" onClose={() => onCloseModal(true)} className={classes.modal}>
      <Collapse in={collapse}>
        <Box mt={2}>
          <Box className={classes.fullName}>{data.name}</Box>
          {/* {data.stage === 2 && ( */}
          {/*  <Box className={classes.subdivision}> */}
          {/*    {data.users[0].subdivision.name}, «{data.nomination.name}» */}
          {/*  </Box> */}
          {/* )} */}
          <Box className={classes.text}>
            <Box>После подтверждения данных чек-листа его редактирование будет невозможно.</Box>
            <Box mt={3}>Подтвердить данные?</Box>
          </Box>
          <Grid container justifyContent="center" spacing={3}>
            <Grid item xs={9}>
              <Button fullWidth variant="contained" color="secondary" onClick={onConfirm} className={classes.btn}>
                Подтвердить и закрыть
              </Button>
            </Grid>
            <Grid item xs={9}>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                onClick={() => onCloseModal(false)}
                className={classes.btnReject}
              >
                Закрыть без подтверждения
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </Modal>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  modal: {
    '& .MuiDialogTitle-root': {
      fontSize: '28px!important',
      paddingLeft: '60px!important',
      paddingRight: '60px!important',
      [down('sm')]: {
        fontSize: '24px!important',
        paddingLeft: '40px!important',
        paddingRight: '40px!important',
      },
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 20px!important',
    minHeight: '45px!important',
    minWidth: '150px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '35px!important',
      minWidth: '130px!important',
    },
  },
  btnReject: {
    fontSize: '16px!important',
    padding: '10px 20px!important',
    minHeight: '45px!important',
    minWidth: '150px!important',
    color: `${palette.primary.dark}!important`,
    backgroundColor: '#6C6C6C!important',
    '&:hover': {
      color: `${palette.text.primary}!important`,
      backgroundColor: `#5b5b5b!important`,
    },
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '35px!important',
      minWidth: '130px!important',
    },
  },
  fullName: {
    fontWeight: 700,
    fontSize: 19,
    padding: '0 50px',
    [down('sm')]: {
      fontSize: 18,
      padding: '0 30px',
    },
  },
  subdivision: {
    fontWeight: 600,
    fontSize: 18,
    color: '#6C6C6C',
    padding: '0 50px',
    [down('sm')]: {
      fontSize: 16,
      padding: '0 30px',
    },
  },
  nomination: {
    fontWeight: 700,
    fontSize: 18,
    padding: '0 50px',
    [down('sm')]: {
      fontSize: 16,
      padding: '0 30px',
    },
  },
  text: {
    fontWeight: 500,
    fontSize: 17,
    padding: '20px 50px 40px',
    [down('sm')]: {
      fontSize: 15,
      padding: '20px 30px 40px',
    },
  },
}))
